/**
 * Centralized registry of all SocketIO event names used across the webapp.
 *
 * WHY: event names were previously hard-coded as string literals in every
 * component that wired up a `socket.on(...)` / `socket.off(...)` / emit. A
 * single typo (e.g. listening on "sent_messsage") silently fails — no error,
 * the handler just never fires. Funnelling every name through these constants
 * means the bug surfaces at import time, and renames are a one-line change.
 *
 * The VALUES here are the wire contract with the backend — they must match
 * exactly what the server emits. Do not "fix" a value to look nicer without a
 * corresponding backend change.
 */

export const SOCKET_EVENTS = {
  // --- Connection lifecycle (socket.io built-ins) ---
  CONNECT: "connect",
  DISCONNECT: "disconnect",
  CONNECT_ERROR: "connect_error",
  // Manager-level reconnection events, fired on `socket.io` (not `socket`).
  RECONNECT: "reconnect",
  RECONNECT_ATTEMPT: "reconnect_attempt",
  RECONNECT_ERROR: "reconnect_error",

  // --- Lead / messaging events ---
  // Unread / lead counters refresh.
  UPDATE_COUNT: "update_count",
  // A note was assigned to a user on a message.
  MESSAGE_NOTES_ASSIGNED: "message_notes_assigned",
  // Inbound message received from a lead.
  RECEIVED_MESSAGE: "received_message",
  // Phase 3a (lambda cutover): the messaging_service lambda persisted an
  // outbound Message and is pushing it back so the optimistic queued bubble
  // can be reconciled into a real message.
  SENT_MESSAGE: "sent_message",
  // Phase 3a: the lambda aborted a send before persisting a Message row.
  SEND_FAILED: "send_failed",

  // --- Webchat ---
  WEBCHAT_DISCONNECT: "webchat_disconnect",

  // NOTE: the email list listens on the MISSPELLED wire name "recieve_message"
  // (sic). The value is preserved verbatim because it must match what the
  // backend emits; renaming requires a coordinated backend change. Kept as a
  // separate constant so the typo lives in exactly one place.
  RECIEVE_MESSAGE_LEGACY_TYPO: "recieve_message",
};
